import {
    UPDATE_DASHBOARD_USER_INFO,
} from '../../actionTypes';

export const updateDashboardUserInfo = (json) => {
    return {
        type: UPDATE_DASHBOARD_USER_INFO,
        payload: json
    };
}